<script>
	import { createEventDispatcher, onMount } from 'svelte';
	import { push } from 'svelte-spa-router';
	import { 
		API, 
		TipoEvento,
		StatusHttp,
		cabecalhoPadraoRequisicao } from '../../utils';
	
	const dispatch = createEventDispatcher();
	let tiposBusca = {};
	let termoBusca;
	let tipoBuscaSelecionado;
	let desabilitarBotaoSubmit = true;
	let modalidadesBusca = [];
	let areasAtuacaoBusca = [];
	let informacosAPICache = null;

	let exibirListagemAreasConhecimento = false;
	let exibirListagemModalidades = false;

    onMount(async () => {
		tiposBusca = {
			NOME: "Nome do(a) coordenador(a) ou discente",
			TITULO_PROJETO: "Título do projeto",
			MODALIDADE_PROJETO: "Modalidade do projeto",
			AREA_ATUACAO_PROJETO: "Área de atuação do projeto (CNPq)"
		};

		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));

		modalidadesBusca = Object.entries(informacosAPICache.modalidades).sort();
		areasAtuacaoBusca = Object.entries(informacosAPICache.areas_conhecimento).sort();
	});	

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Buscando ...',
		});
		
		if (tipoBuscaSelecionado == 'MODALIDADE_PROJETO' || tipoBuscaSelecionado == 'AREA_ATUACAO_PROJETO')
			push(`#/sdg/trabalhos/consulta/projetos/listagem/${tipoBuscaSelecionado}/${termoBusca}`)
		else {
			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('sdg/trabalhos/consulta'), {
				method: 'POST',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					tipoBusca: tipoBuscaSelecionado, 
					termo: termoBusca
				})
			}).catch(erros => {
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Erro no servidor',
					conteudo: "Erro interno no servidor, tente novamente mais tarde."
				});
			});
	
			// pega o json do retorno da resposta
			const json = await resposta.json();
	
			if (resposta.status == StatusHttp.OK) {
				if (Object.keys(json.dados).length > 0) {
					localStorage.setItem('AVAL_RESULTADO_CONSULTA_TRABALHOS', JSON.stringify({ 
						dados: Object.values(json.dados)
					}));
					
					setTimeout( () => tipoBuscaSelecionado == 'NOME' ? push("#/sdg/trabalhos/consulta/usuarios") : push("#/sdg/trabalhos/consulta/projetos"), 400);
				} else {
					dispatch('routeEvent', {
						tipo: TipoEvento.ABRIR_MODAL,
						titulo: 'Aviso',
						conteudo: 'Nenhuma informação encontrada com os dados informados.'
					});
				}
			} else {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Erro...',
					conteudo: json?.mensagem
				});
			}
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}

	const ajustarBusca = (evento) => {
		if (tipoBuscaSelecionado == null)
			desabilitarBotaoSubmit = true;
		else
			desabilitarBotaoSubmit = false;

		if (tipoBuscaSelecionado == 'MODALIDADE_PROJETO') {
			exibirListagemModalidades = true;
			exibirListagemAreasConhecimento = false;
		} else if (tipoBuscaSelecionado == 'AREA_ATUACAO_PROJETO') {
			exibirListagemModalidades = false;
			exibirListagemAreasConhecimento = true;
		} else {
			exibirListagemModalidades = false;
			exibirListagemAreasConhecimento = false;
			termoBusca = "";
		}
	}
</script>

<main>
	<section class="hero is-fullheight">
		<div class="hero-body">
			<div class="container">
				<figure 
					class="container image is-128x128"
					style="margin-bottom: 0px;border-bottom:1px solid #777">
					<img src="logo.png" alt="Logo AVAL" />
				</figure>
				
				<div class="column is-12">
					<div class="mb-6 has-text-centered">
						<h3 class="title has-text-black">Trabalhos</h3>
						<p class="is-size-6 subtitle has-text-black">Trabalhos Apresentados na Semana de Graduação</p>
					</div>

					<form method="post" on:submit|preventDefault={submeterFormulario}>
						<div class="columns">
							<div class="column is-12">
								<div class="select is-primary is-large is-fullwidth">
									<select bind:value={tipoBuscaSelecionado} name="tipo_busca" on:change={ajustarBusca} required>
										<option value="">Selecione o tipo de consulta...</option>
										{#each Object.entries(tiposBusca) as [chave, valor]}
										<option value="{chave}">{valor}</option>
										{/each}
									</select>
								</div>
							</div>
						</div>
						<div class="columns">

							{#if exibirListagemModalidades}
							
							<div class="column is-9">
								<div class="field">
									<div class="select is-primary is-large is-fullwidth">
										<select bind:value={termoBusca} name="termo_busca" required>
											<option value="">Selecione uma modalidade...</option>
											{#each modalidadesBusca as [chave, valor]}
											<option value="{chave}">{valor}</option>
											{/each}
										</select>
									</div>
								</div>
							</div>
							
							{:else if exibirListagemAreasConhecimento}

							<div class="column is-9">
								<div class="field">
									<div class="select is-primary is-large is-fullwidth">
										<select bind:value={termoBusca} name="termo_busca" required>
											<option value="">Selecione uma área de atuação...</option>
											{#each areasAtuacaoBusca as [chave, valor]}
											<option value="{chave}">{valor}</option>
											{/each}
										</select>
									</div>
								</div>
							</div>

							{:else}
							
							<div class="column is-9">
								<div class="field">
									<input 
										bind:value={termoBusca}
										name="termo_busca" 
										type="text" 
										minlength="4"
										maxlength="64"
										placeholder="Digite aqui o que você procura" 
										class="input is-large is-primary is-fullwidth" required>
								</div>
							</div>

							{/if}

							<div class="column is-3">
								<div class="field">
									<button 
										type="submit" 
										disabled="{desabilitarBotaoSubmit}" 
										class="button is-primary is-large is-fullwidth">
										Buscar
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>

		<div class="notification is-light has-text-centered">
			<a href="#/">Clique aqui</a> para retornar à tela inicial &#9679; <a href="http://www.aval.cetreina.uerj.br/sdg-2021/" target="_blank">Clique aqui</a> para consultas anteriores a 2022
		</div>
	</section>
</main>